import {postEditSchema} from "mock/cms/post/views/editPage";

export default postEditSchema
